var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isRouterAlive)?_c('router-view',{class:_vm.langClass}):_vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }